import { AdvisorWithFullName } from '../types/Types';
import { AgentForProxyDTO } from '../../../../common/js/agent/AgentForProxyDTO';

/**
 * preserves digits, word characters, underscores, and (many) whitespace
 * remove special characters such as #-!~
 * Ex: 1. turns "O'connor" into "Oconnor"
 *   2. "john   jr.   o'connor" => "john   jr   oconnor"
 */
export function removeSpecialCharacters(input: string): string {
  return input.replace(/[^\w\s]/gi, '');
}

/**
 * Ex: "john   jr.   o'connor" => "john jr. o'connor"
 */
export function removeExtraSpaces(input: string): string {
  return input.trim().replace(/ +(?= )/g, '');
}

export function cleanupKeyword(input: string): string {
  return removeExtraSpaces(removeSpecialCharacters(input)).toLocaleLowerCase();
}

export function matchesAdvisorName(firstName: string, lastName: string, partialName: string): boolean {
  // Empty string is ignored
  if (!(partialName && cleanupKeyword(partialName))) {
    return true;
  }

  const cleanPartialName = cleanupKeyword(partialName);
  const [firstWord, secondWord] = cleanPartialName.split(' ');
  const cleanReversePartialName = `${secondWord} ${firstWord}`;

  const cleanFirstName = cleanupKeyword(firstName);
  const cleanLastName = cleanupKeyword(lastName);
  const fullName = `${cleanFirstName} ${cleanLastName}`;
  const reverseFullName = `${cleanLastName} ${cleanFirstName}`;

  return [cleanFirstName, cleanLastName, fullName, reverseFullName].some(
    (name) => name.includes(cleanPartialName) || name.includes(cleanReversePartialName)
  );
}

export function getAdvisorWithFullName(advisor: AgentForProxyDTO): AdvisorWithFullName {
  return {
    fullName: advisor.displayName
      ? `${advisor.displayName} ${advisor.lastName}`
      : `${advisor.firstName} ${advisor.lastName}`,
    advisor,
    producerGroup: null,
    selectionId: advisor && advisor.producerId,
  };
}
